/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupseatlimit2Inputs */

const en_signupseatlimit2 = /** @type {(inputs: Signupseatlimit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seats`)
};

const de_signupseatlimit2 = /** @type {(inputs: Signupseatlimit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plätze`)
};

/**
* | output |
* | --- |
* | "Seats" |
*
* @param {Signupseatlimit2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupseatlimit2 = /** @type {((inputs?: Signupseatlimit2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupseatlimit2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupseatlimit2(inputs)
	return de_signupseatlimit2(inputs)
});
export { signupseatlimit2 as "signupSeatLimit" }